module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10+ Aura Glow.f6cde125.png";